import { Outlet } from "react-router";

function AuthLayout({ children }: { children: React.ReactNode }) {
  return <div>{children}</div>;
}

export default function App() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
